var React = require('react');

function PlansIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 6V4h18v2H3zm20 2h-2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8H1V2h22v6zM5 8h14v12H5V8zm10 3H9v2h6v-2z","fill":"#fff"}));
}

PlansIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = PlansIcon;

PlansIcon.default = PlansIcon;
